import { useEffect, useState } from 'react';

import { COOKIE_NAME } from "~/const";
import { trans } from "~/providers/lang";
import { getCookieValue, setCookieValue } from "~/utils/utils";

import "./style.less";

interface ICookieBar {
	onConfirm: () => void;
}

export default function CookieBar({
	onConfirm = () => {},
}: ICookieBar) {
	const cookieVal = getCookieValue(COOKIE_NAME);

	const [state, setState] = useState({
		showCookiesBar: cookieVal === "",
	});

	function reject() {
		setState(prev => ({
			...prev,
			showCookiesBar: false,
		}));
		setCookieValue(COOKIE_NAME, "0", {
			expiration: Infinity,
			path: "/",
		});
	}

	function confirm() {
		setState(prev => ({
			...prev,
			showCookiesBar: false,
		}));
		setCookieValue(COOKIE_NAME, "1", {
			expiration: Infinity,
			path: "/",
		});
		onConfirm();
	}

	useEffect(() => {
		if (cookieVal === "1") {
			onConfirm();
		}
	}, []);

	return <div className="cookies-cover">
		{ state.showCookiesBar && <div className="cks-bar">
			<p>
				{trans("cookie.msg")}
			</p>
			<div></div>
			<div className="buttons">
				<button type="button" className="reject-btn" onClick={reject}>
					{trans("cookie.buttonCancel")}
				</button>
				<button type="button" className="allow-btn" onClick={confirm}>
					{trans("cookie.buttonConfirm")}
				</button>
			</div>
		</div>}
	</div>;
}
